import { NavLink } from 'react-router-dom'
import { Copy } from 'lucide-react'
import { useToast } from '../../components/Toast.jsx'
import { useSession } from '../../session'

// Pieces shared by a practice's pages: the section tabs, a client's logo,
// and a link to pass on.

// "Main & Partners" -> MP: words that start with a letter or digit.
export const initials = (name) => String(name || '').split(/\s+/).filter((w) => /^[\p{L}\p{N}]/u.test(w)).slice(0, 2).map((w) => w[0].toUpperCase()).join('') || '?'

export const logoSrc = (path) => {
  const p = String(path || '').trim()
  if (!p) return ''
  return /^(https?:)?\/\//i.test(p) ? p : `${import.meta.env.VITE_API_URL || ''}${p}`
}

/** An amount in a client's own currency. */
export const clientMoney = (value, currency) => {
  const n = Number(value || 0)
  try {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'USD', currencyDisplay: 'narrowSymbol', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number.isNaN(n) ? 0 : n)
  } catch {
    return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  }
}

/** "October", from 2026-10. */
export const monthName = (ym) => {
  const [y, m] = String(ym || '').split('-').map(Number)
  if (!y || !m) return ''
  return new Date(y, m - 1, 1).toLocaleString('en-US', { month: 'long' })
}

export function usePracticeAdmin() {
  const { roles = [] } = useSession()
  return roles.includes('admin')
}

/** Clients · Staff · Settings, for a practice's admins (staff see Clients only). */
export function PracticeTabs() {
  const admin = usePracticeAdmin()
  if (!admin) return null
  return (
    <nav className="section-tabs" aria-label="Your practice">
      <NavLink to="/practice" end>Clients</NavLink>
      <NavLink to="/practice/staff">Staff</NavLink>
      <NavLink to="/practice/settings">Settings</NavLink>
    </nav>
  )
}

/** A link to pass on, with a Copy button. */
export function CopyLink({ text, link, label = 'Link' }) {
  const { notify } = useToast()
  const copy = async () => {
    try { await navigator.clipboard.writeText(link); notify('Link copied') } catch { window.prompt('Copy the link:', link) }
  }
  return (
    <div className="acct-link">
      {text && <p className="doc-hint">{text}</p>}
      <div className="acct-link-row">
        <input readOnly value={link} onFocus={(e) => e.target.select()} aria-label={label} />
        <button type="button" className="ci-btn ci-btn-ghost ci-btn-sm" onClick={copy}><Copy size={14} />Copy</button>
      </div>
    </div>
  )
}
